<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getWorkOrderExecutions"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="shifts" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Shift" id="filter-" size="sm" :model.sync="filter.shiftId" @input="getShifts" @focus="getShifts" />
					<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="lotNo" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Process Number" id="filter-" size="sm" :model.sync="filter.workOrderProcessDetailId" @input="getWorkOrderProcessDetails" @focus="getWorkOrderProcessDetails" />
					<app-input-combobox-autocomplete :options="billOfProcessDetails" optionsLabel="subProcessNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Sub Process" id="filter-" size="sm" :model.sync="filter.billOfProcessDetailId" @input="getBillOfProcessDetails" @focus="getBillOfProcessDetails" />
					<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine" id="filter-" size="sm" :model.sync="filter.machineId" @input="getMachines" @focus="getMachines" />
				</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Operator" id="filter-" size="sm" :model.sync="filter.operatorUserName" @input="getUserInfos" @focus="getUserInfos" />
					<app-input-datetimepicker-range id="fieldset-start-production" label-cols-sm="4" label-cols-lg="3" label="Start Production" size="sm" :modelFrom.sync="filter.startProductionFrom" :modelTo.sync="filter.startProductionTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-datetimepicker-range id="fieldset-finish-production" label-cols-sm="4" label-cols-lg="3" label="Finish Production" size="sm" :modelFrom.sync="filter.finishProductionFrom" :modelTo.sync="filter.finishProductionTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<!-- <app-input-textbox id="fieldset-qty-plan" label-cols-sm="4" label-cols-lg="3" label="Qty Plan" label-for="filter-qty-plan" size="sm" :model.sync="filter.qtyPlan" /> -->
					<app-input-textbox-range id="fieldset-qty-range" label-cols-sm="4" label-cols-lg="3" label="Qty Plan" size="sm" :modelFrom.sync="filter.qtyPlanFrom" :modelTo.sync="filter.qtyPlanTo"></app-input-textbox-range>
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm" :model.sync="filter.documentStatusIdSelected" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getWorkOrderExecutions"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Work Order Execution</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<!-- <b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/workorderexecution/WorkOrderExecution.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown> -->
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<!-- <b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button> -->

					<!-- <b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay> -->

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-workorderexecution" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="workOrderExecutions" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="workOrderExecutions.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Work Order Process Number" class="table-filter">
							<v-select append-to-body label="lotNo" :options="workOrderProcessDetails" :value="filter.workOrderProcessDetailId" :reduce="item => item.id" v-model="filter.workOrderProcessDetailId" :filterable="true" @input="getWorkOrderExecutionsWithoutLoading" @search="getWorkOrderProcessDetails"></v-select>
						</b-th>
						<b-th stacked-heading="Work Order Sub Process" class="table-filter">
							<v-select append-to-body label="subProcessNumber" :options="billOfProcessDetails" :value="filter.billOfProcessDetailId" :reduce="item => item.id" v-model="filter.billOfProcessDetailId" :filterable="true" @input="getWorkOrderExecutionsWithoutLoading" @search="getBillOfProcessDetails"></v-select>
						</b-th>						
						<b-th stacked-heading="Shift" class="table-filter">
							<v-select append-to-body label="name" :options="shifts" :value="filter.shiftId" :reduce="item => item.id" v-model="filter.shiftId" :filterable="true" @input="getWorkOrderExecutionsWithoutLoading" @search="getShifts"></v-select>
						</b-th>
						<b-th stacked-heading="Machine" class="table-filter">
							<v-select append-to-body label="code" :options="machines" :value="filter.machineId" :reduce="item => item.id" v-model="filter.machineId" :filterable="true" @input="getWorkOrderExecutionsWithoutLoading" @search="getMachines"></v-select>
						</b-th>
						<b-th stacked-heading="Line" class="table-filter">

						</b-th>
						<b-th stacked-heading="Operator" class="table-filter">
							<v-select append-to-body label="firstName" :options="userInfos" :value="filter.operatorUserName" :reduce="item => item.userName" v-model="filter.operatorUserName" :filterable="true" @input="getWorkOrderExecutionsWithoutLoading" @search="getUserInfos"></v-select>
						</b-th>
						<b-th stacked-heading="Start Production" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-start-production" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Production" size="sm" :modelFrom.sync="filter.startProductionFrom" :modelTo.sync="filter.startProductionTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getWorkOrderExecutionsWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Finish Production" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-finish-production" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Finish Production" size="sm" :modelFrom.sync="filter.finishProductionFrom" :modelTo.sync="filter.finishProductionTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getWorkOrderExecutionsWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Qty Plan" class="table-filter">
							<b-form-input id="input-qty-plan-from-table" @input="getWorkOrderExecutionsWithoutLoading" placeholder="Qty Plan From" v-model="filter.qtyPlanFrom" size="sm"></b-form-input>
							<b-form-input id="input-qty-plan-to-table" @input="getWorkOrderExecutionsWithoutLoading" placeholder="Qty Plan To" v-model="filter.qtyPlanTo" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Document Status" class="table-filter">
							<v-select append-to-body label="name" :options="documentStatuss" :value="filter.documentStatusIdSelected" :reduce="item => item.id" v-model="filter.documentStatusIdSelected" :filterable="true" @input="getWorkOrderExecutionsWithoutLoading" @search="getDocumentStatuss"></v-select>
						</b-th>

						<!-- <b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th> -->
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(workOrderProcess)="row">
						<!-- {{ row.item.workOrderProcessDetail != null ? row.item.workOrderProcessDetail.lotNo : "" }} -->
						<span v-if="row.item.workOrderProcessDetail != null && row.item.workOrderProcessDetail.lotNo != null">
							<a v-if="row.item.documentStatusId == 'CLOSED'" @click="() => ( $router.push({ name: 'workorderexecutiondetail', params : { id: row.item.id } }))" class="a-link-detail">
								{{ row.item.workOrderProcessDetail.lotNo != null && row.item.workOrderProcessDetail.lotNo != "" ?
									(typeof row.item.workOrderProcessDetail.lotNo == 'string') ?
										row.item.workOrderProcessDetail.lotNo.slice(0, 20) + (row.item.workOrderProcessDetail.lotNo.length > 20 ? "..." : "" ) : row.item.workOrderProcessDetail.lotNo : "" }}
							</a>
							<a v-if="row.item.documentStatusId == 'IN_PROGRESS' || row.item.documentStatusId == 'IN_PROGRESS_PRODUCTION'" @click="navigateToScanScreen(row.item.id)" class="a-link-detail">
								{{ row.item.workOrderProcessDetail.lotNo != null && row.item.workOrderProcessDetail.lotNo != "" ?
									(typeof row.item.workOrderProcessDetail.lotNo == 'string') ?
										row.item.workOrderProcessDetail.lotNo.slice(0, 20) + (row.item.workOrderProcessDetail.lotNo.length > 20 ? "..." : "" ) : row.item.workOrderProcessDetail.lotNo : "" }}
							</a>
						</span>
					</template>

					<template v-slot:cell(shift)="row">
						{{ row.item.shift != null ? row.item.shift.name : "" }}
					</template>

			<template v-slot:cell(subProcessNumber)="row">
				{{ row.item.billOfProcessDetail != null ? row.item.billOfProcessDetail.subProcessNumber : "" }}
			</template>
			<template v-slot:cell(machine)="row">
				{{ row.item.machine != null ? row.item.machine.code : "" }}
			</template>
			<template v-slot:cell(line)="row">
				{{ row.item.machine != null ? ((row.item.machine.lineCode != null) ? row.item.machine.lineCode.code : "") : "" }}
			</template>
			<template v-slot:cell(operator)="row">
				{{ row.item.operator != null ? row.item.operator.firstName : "" }}
			</template>
			<template v-slot:cell(startProduction)="row">
				{{ row.item.startProduction | moment("DD-MMM-YYYY HH:mm") }}
			</template>
			<template v-slot:cell(finishProduction)="row">
				{{ row.item.finishProduction | moment("DD-MMM-YYYY HH:mm") }}
			</template>
			<template v-slot:cell(documentStatus)="row">
				<div class="two-item" v-if="!isMobileDevice">
					<span>{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }} </span>
					<span :class="getRectangleClass(row.item.documentStatusId)">&nbsp;</span>
				</div>
				<div v-else>
					<span :class="getRectangleClass(row.item.documentStatusId)">&nbsp;</span>
				</div>
			</template>

					<template v-slot:cell(front-action)="row">
						<!-- <div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div> -->
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-combobox optionsLabel="sequence" label-cols-sm="12" :model="row.item.billOfProcessDetailId" label="Work Order Sub Process" :selected="row.item.billOfProcessDetail != null ? row.item.billOfProcessDetail.sequence : ''" :isEditable="false" :isUpdatable="true" />
						<app-label label-cols-lg="12" size="sm" label="Sub Process Number" :model="(row.item.billOfProcessDetail != null) ? row.item.billOfProcessDetail.subProcessNumber : null"  />
						<app-label label-cols-lg="12" size="sm" label="LotNo" :model="(row.item.workOrderProcessDetail != null) ? row.item.workOrderProcessDetail.lotNo : null"  />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.machineId" label="Machine" :selected="row.item.machine != null ? row.item.machine.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="firstName" label-cols-sm="12" :model="row.item.operatorUserName" label="Operator" :selected="row.item.operator != null ? row.item.operator.firstName : ''" :isEditable="false" :isUpdatable="true" />
						<!-- <app-label label-cols-lg="12" size="sm" label="Machine" :model="(row.item.machine != null) ? row.item.machine.name : null"  /> -->
						<app-input-datetimepicker id="fieldset-start-production" label-cols-lg="12"  label="Start Production" size="sm" :model.sync="row.item.startProduction"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-datetimepicker id="fieldset-finish-production" label-cols-lg="12"  label="Finish Production" size="sm" :model.sync="row.item.finishProduction"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-plan" label-cols-lg="12"  label="Qty Plan" label-for="input-qty-plan" size="sm" :model.sync="row.item.qtyPlan"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.documentStatusId" label="Document Status" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(workOrderExecutionsPaging != null ? workOrderExecutionsPaging.dataCount : 0)"
									:per-page="(workOrderExecutionsPaging != null ? workOrderExecutionsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-workorderexecution.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-workorderexecution.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-workorderexecution.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }

	.two-item {
		display: flex;
		gap: 10px;
		justify-content: space-between;
		align-items: center;
	}
	.rectangle {
		display: inline-block;
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}

	// @media screen and (max-width: 400px) {
	// 	.two-item {
	// 		justify-content: space-around;
	// 	}
	// 	.rectangle {
	// 		width: 23px;
	// 		height: 23px;
	// 		margin-top: 10px;
	// 	}
	// }

	.rectangle-danger {
		background-color: #DC3545;
	}
	.rectangle-warning {
		background-color: #FFC107;
	}
	.rectangle-success {
		background-color: #28A745;
	}
</style>
<script>
import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionList from '@/models/WorkOrderExecution/WorkOrderExecutionList';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppLabel from '@/components/AppLabel';
import AppInputTextarea from '@/components/AppInputTextarea';
import ShiftFilter from '@/filters/Shift/ShiftFilter';
import Shift from '@/models/Shift/Shift';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import BillOfProcessDetailFilter from '@/filters/BillOfProcess/BillOfProcessDetailFilter';
import BillOfProcessDetail from '@/models/BillOfProcess/BillOfProcessDetail';
import MachineFilter from '@/filters/Machine/MachineFilter';
import Machine from '@/models/Machine/Machine';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextboxRange from '@/components/AppInputTextboxRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import ProductionControlTimeDetailFilter from '@/filters/ProductionControlTime/ProductionControlTimeDetailFilter';
import ProductionControlTimeDetail from '@/models/ProductionControlTime/ProductionControlTimeDetail';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		WorkOrderExecution, 
		WorkOrderExecutionList, 
		WorkOrderExecutionFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextboxRange,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		AppLabel,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"workOrderProcess": {}, "class" : "th-lot-no first-child", "label" : "WOP - Lot No", key: 'workOrderProcess', sortable: true}, 
				{"subProcessNumber": {}, "class" : "th-sub-process-number d-stack-none", "label" : "Work Order Process Sub Number", key: 'subProcessNumber', sortable: true}, 
				{"shift": {}, "class" : "th-shift d-stack-none", "label" : "Shift", key: 'shift', sortable: true}, 
				{"machine": {}, "class" : "th-machine d-stack-none", "label" : "Machine", key: 'machine', sortable: true}, 
				{"line": {}, "class" : "th-line", "label" : "Line", key: 'line', sortable: false}, 
				{"operator": {}, "class" : "th-operator d-stack-none", "label" : "Operator", key: 'operator', sortable: true}, 
				{"startProduction": {}, "class" : "th-start-production d-stack-none", "label" : "Start Production", key: 'startProduction', sortable: true}, 
				{"finishProduction": {}, "class" : "th-finish-production d-stack-none", "label" : "Finish Production", key: 'finishProduction', sortable: true}, 
				{"qtyPlan": {}, "class" : "th-qty-plan d-stack-none", "label" : "Qty Plan", key: 'qtyPlan', sortable: true}, 
				{"documentStatus": {}, "class" : "th-document-status last-child", "label" : "Document Status", key: 'documentStatus', sortable: true}, 
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			workOrderExecutions: [],
			workOrderExecutionsPaging: {},
			shifts : [],
			workOrderProcessDetails : [],
			billOfProcessDetails : [],
			machines : [],
			userInfos : [],
			documentStatuss : [],
			workOrderExecutionDetails : [],
			workOrderExecutionControlTimes : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			isMobileDevice: false,
		}
	},	
	methods : {
		setSelectedOperator(item) {
			console.log("filter operator");
			if(item == null || item == undefined) {
				this.filter.operator = null;
				this.filter.operatorUserName = null;
			} else {
				this.filter.operator = item;
				this.filter.operatorUserName = item.userName;
			}
			console.log("filterUpdated", this.filter.operatorUserName);
		},
		getRectangleClass(documentStatus) {
			let cls = "rectangle";
			if(documentStatus == "CLOSED") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}
			return cls;
		},
		getWorkOrderExecutions : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			if(this.filter.documentStatusIdSelected) {
				this.filter.documentStatusId = this.filter.documentStatusIdSelected;
			}
			else {
				this.filter.documentStatusId = "IN_PROGRESS,IN_PROGRESS_PRODUCTION";
			}

			this.filter["isDataFromLast7Days"] = false;

			if (!this.filter.shiftId && !this.filter.workOrderProcessDetailId && !this.filter.billOfProcessDetailId && !this.filter.machineId && !this.filter.operatorUserName && !this.filter.startProductionFrom && !this.filter.startProductionTo && !this.filter.qtyPlanFrom && !this.filter.qtyPlanTo && !this.filter.documentStatusIdSelected ) {
				this.filter["isDataFromLast7Days"] = true;
			}

			WorkOrderExecution.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
					this.workOrderExecutionsPaging = result
					this.filter.documentStatusId = null;
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderExecutionsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			if(this.filter.documentStatusIdSelected) {
				this.filter.documentStatusId = this.filter.documentStatusIdSelected;
			} else {
				this.filter.documentStatusId = "IN_PROGRESS,IN_PROGRESS_PRODUCTION";
			}

			this.filter["isDataFromLast7Days"] = false;

			if (!this.filter.shiftId && !this.filter.workOrderProcessDetailId && !this.filter.billOfProcessDetailId && !this.filter.machineId && !this.filter.operatorUserName && !this.filter.startProductionFrom && !this.filter.startProductionTo && !this.filter.qtyPlanFrom && !this.filter.qtyPlanTo && !this.filter.documentStatusIdSelected ) {
				this.filter["isDataFromLast7Days"] = true;
			}

			WorkOrderExecution.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
					this.workOrderExecutionsPaging = result
				}
			})
			.catch(error => {});
		},
		getShifts : async function(input) {
			let filter = new ShiftFilter();
			if (input != undefined) {
				filter.name = input;
			}
			Shift.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.shifts = result.data
				}
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.lotNo = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		getBillOfProcessDetails : async function(input) {
			let filter = new BillOfProcessDetailFilter();
			if (input != undefined) {
				filter.subProcessNumber = input;
			}
			BillOfProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			filter.code = "IN_PROGRESS_PRODUCTION,CLOSED";
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new WorkOrderExecutionFilter();
			this.getWorkOrderExecutions();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getWorkOrderExecutions();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				WorkOrderExecution.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			WorkOrderExecution.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			WorkOrderExecution.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			WorkOrderExecution.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'workorderexecutionedit';
						if(this.isScannerMode) {
							createRoute = 'workorderexecutionscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			WorkOrderExecution.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workorderexecutionedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			WorkOrderExecution.deleteData(this, id).then(result => {
				if (result)
				{
					this.getWorkOrderExecutions();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				WorkOrderExecution.deleteMultipleData(this).then(result => {
					this.getWorkOrderExecutions();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
				this.isMobileDevice = true;
			} else {
				this.isStacked = false;
				this.isMobileDevice = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},

		async navigateToScanScreen(idParam) {
			await this.$router.push({ name: 'workorderexecutionscan', params: { id: idParam } });
			// Emit the custom event to notify the child component
			//this.$root.$emit('navigateToScanScreen', 8, idParam);
		},

		scrollRight() {
			var tableWorkOrderExecutionParent = document.getElementById('table-list-workorderexecution').parentNode;
			tableWorkOrderExecutionParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableWorkOrderExecutionParent.scrollWidth - tableWorkOrderExecutionParent.offsetWidth) == Math.ceil(tableWorkOrderExecutionParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableWorkOrderExecutionParent = document.getElementById('table-list-workorderexecution').parentNode;
			tableWorkOrderExecutionParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableWorkOrderExecutionParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new WorkOrderExecutionFilter();
		this.getShifts()
		this.getWorkOrderProcessDetails()
		this.getBillOfProcessDetails()
		this.getMachines()
		this.getUserInfos()
		this.getDocumentStatuss()
	},
	mounted(){

		console.log("state user", this.$store.state);

		let breadcrumb =[
			"Master Data", 
			"Work Order Execution"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getWorkOrderExecutions();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getWorkOrderExecutions();
			}
		},
		sortDesc: {
			handler: function() {
				this.getWorkOrderExecutions();
			}
		},
		currentPage: {
			handler: function() {
				this.getWorkOrderExecutions();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getWorkOrderExecutions();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				WorkOrderExecution.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "workorderexecutionindex") {
					this.getWorkOrderExecutionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "work_order_execution").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
